<template lang="pug">
.body-component
  el-card.sizeCard
    div(slot="header", class="clearfix")
      span.subtitle {{titulo}}
    .pad
      el-row
        el-col
        app-label.label-diaria(
          label="Valor da diária:"
        )
      el-row
        app-double-input.input(
          v-model="valor"
        )
      el-row
        app-label.label-funcionarios(
          label="Número de funcionários:",
        )
      el-row
        validation-provider(rules="required", v-slot="{ errors }")
          el-input-number.input(
            type="number",
            controls-position="right"
            size="small"
            :min="0"
            v-model="quantidade"
            name="nº de funcionários"
          )
          span.help.erro {{ errors[0] }}
      app-display.label-custas(label="Custo Diárias (por funcionário): ", :required="false", :content="totalPorFuncionario")
      app-display(label="Total Custo Pessoal: ", :required="false", :content="totalPessoal")
</template>
<script>
import utils from '@/utils/utils'
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'

export default {
  props: {
    titulo: {
      type: String,
      required: true
    },
    numeroDiarias: {
      type: Number,
      default: 0
    },
    valor: {
      type: Number,
      default: 0
    },
    quantidade: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    scope: {
      type: String,
      required: true
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppLabel,
    AppDoubleInput
  },

  computed: {
    totalPorFuncionario () {
      const result = this.numeroDiarias * this.valor
      return `R$ ${utils.format(result)}`
    },
    totalPessoal () {
      const result = this.numeroDiarias * this.valor * this.quantidade
      return `R$ ${utils.format(result)}`
    }
  }
}
</script>
<style lang="scss" scoped>
.body-component {
  padding-top: 20px;
}
.label-diaria {
  display: inline-block;
  padding-right: 10px;
  font-weight: bold;
}
.input {
  width: 150px;
}
.pad {
  padding-left: 10px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.label-funcionarios {
  padding-top: 8px;
  margin: 2px 2px 2px 2px;
  font-weight: bold;
}
.label-custas {
  padding-top: 8px;
  margin: 2px 2px 2px 2px;
}
.subtitle {
  color: #353535;
  font-size: 18px;
}
.sizeCard {
  height: 310px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppDiariasCustas.vue